import {
  bizmatesSiteHomeUrl,
  errorCodes,
  supportedBrowsers,
  contractTypes,
  browsers
} from '@/utils/constants';
import {
  getParentSiteUrl
} from '@/utils/urlHelper';
import logger from '@/modules/Logger';
import router from '../router';
import UAParser from 'ua-parser-js';
import mainStore from '@/store/index';
import bizTransport from '@/modules/bizTransport';
import { getApiMethod } from '@/modules/apiSelector';

let checkUserLocalTime = (lessonId = '') => {
  let iat = mainStore.getters.getIat;
  if (isNaN(iat)) {
    console.log('Server time (iat) is NaN');
    return false;
  }
  const consolebizTransport = new bizTransport(mainStore.getters.logTransportToken);
  logger.add(consolebizTransport);

  const serverTimeinUTC = mainStore.getters.getIat * 1000;
  const systemTimeinUTC = currentLocalDateTimeInUTC(new Date());
  const systemTimeinUTCUnixTimestamp = Math.floor(systemTimeinUTC.getTime());
  const serverTimeLocaleString = (new Date(serverTimeinUTC)).toLocaleTimeString('en-US');
  const systemTimeLocaleString = (new Date(systemTimeinUTCUnixTimestamp)).toLocaleTimeString('en-US');

  // Calculate the time difference in milliseconds
  const timeDifference = (serverTimeinUTC - systemTimeinUTCUnixTimestamp) / 1000;
  console.log('Server time (' + serverTimeinUTC + ') ' + formatTime(serverTimeinUTC, mainStore.state.accType) + 
  ' versus local time (' + systemTimeinUTCUnixTimestamp + ') ' + formatTime(systemTimeinUTC, mainStore.state.accType));

  // If time is late
  if (timeDifference > 300) {
    logger.error('Local time is late by more than 5 minutes (' + timeDifference + 
    ' difference) (Local time is ' + systemTimeLocaleString + ' vs ' + serverTimeLocaleString + ')',{
      event_type:24,
      lesson_id: (lessonId || '')
    });
    redirectToHome(errorCodes.ME001, lessonId);
  }

  // If time is advance
  if (timeDifference < -300) {
    logger.error('Local time is advance by more than 5 minutes (' + timeDifference + ' difference) (Local time is ' + 
    systemTimeLocaleString + ' vs ' + serverTimeLocaleString + ')',{
      event_type:24,
      lesson_id: (lessonId || '')
    });
    redirectToHome(errorCodes.ME001, lessonId);
  }

  logger.remove(consolebizTransport);

  logger.info('Local time ' + systemTimeLocaleString + ' vs Bizmates server time ' + serverTimeLocaleString);
  logger.info('Force sending of logs', { operation: 'send-batch-log' });
};

let redirectToHome = (errorCode, lessonId = '') => {
  if (bizmatesSiteHomeUrl) {
    logger.error(`Redirect to homepage with code ${errorCode}`, {
      event_type: 26, 
      lesson_id: lessonId || ''
    });
    logger.info('Force sending of logs', { operation: 'send-batch-log' });
    router.push({ name: 'RedirectToHome', query: { code: errorCode } });
  }
};

let redirectToJwtError = () => {
  router.push({ name: 'JwtError' });
};

let redirectToLessonGeneratorLogin = () => {
  router.push({ name: 'TrialLessonGenerator' });
};

let currentLocalDateTimeInUTC = (date) => {
  const utcYear = date.getUTCFullYear();
  const utcMonth = date.getUTCMonth();
  const utcDate = date.getUTCDate();
  const utcHours = date.getUTCHours();
  const utcMinutes = date.getUTCMinutes();
  const utcSeconds = date.getUTCSeconds();

  return new Date(Date.UTC(utcYear, utcMonth, utcDate, utcHours, utcMinutes, utcSeconds));
};

let formatTimeTz = (tsCurrentFormat, timeZone = null, option = null) => {
  const date = new Date(tsCurrentFormat);
  if (!option) {
    option = {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit'
    };
  }
  option = timeZone !== null ? Object.assign(option, { timeZone }) : option;
  return date.toLocaleTimeString('en-US', option);
};

let formatTime = (unixTsSeconds, accType, option = null) => {
  const timezone = accType === 's' ? 'Asia/Tokyo' : 'Asia/Manila';
  return formatTimeTz(unixTsSeconds, timezone, option);
};

let formatDateTimeEn = unixTsSeconds => {
  const locale = 'en-US';
  const date = new Date(unixTsSeconds * 1000);

  return date.toLocaleTimeString(locale, {
    hour12: true,
    month: 'long',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'long',
    timeZone: 'Asia/Manila'
  });
};

let formatDateTimeJp = unixTsSeconds => {
  const locale = 'ja-JP-u-ca-japanese';
  const date = new Date(
    new Date(unixTsSeconds * 1000).toLocaleString('en-US', {
      timeZone: 'Asia/Tokyo'
    })
  );

  let d = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds()
    },
    dow = date.toLocaleDateString(locale, { weekday: 'short' });

  Object.keys(d).forEach(prop => {
    if (d[prop] < 10) d[prop] = '0' + d[prop];
  });

  return `${d.y}-${d.m}-${d.d} (${dow}) ${d.h}:${d.i}`;
};

let dateTimeFormattingFunc = accountType => {
  if (accountType === 't') {
    return formatDateTimeEn;
  }
  return formatDateTimeJp;
};

let toggleBodyClass = toggleOn => {
  document.body.classList.toggle('dark', toggleOn);
};

const redirectToChatHistory = (accountType, lessonId) => {
  // check our beta-level flag, if we want to use the new ChatHistory page
  const ifUseNewChatHistory = getApiMethod('ifUseNewChatHistory');
  if (ifUseNewChatHistory()) {
    router.push({ name: 'LessonChatHistory', params: { lessonId: lessonId } });
    return;
  }

  const isStudent =  accountType === 's';
  const siteSection = isStudent ? 'student' : 'trainer';
  const parentSiteHistoryUrl = getParentSiteUrl(
    null,
    isStudent
  );
  
  if (parentSiteHistoryUrl) {
    window.location = `${parentSiteHistoryUrl}/MyBizmates/${siteSection}/mystage/history/${lessonId}`;
  }
};

const redirectToLesson = (lessonId) => {
    router.push({ name: 'Lesson', params: { lessonId: lessonId } });
    return;
};

/**
 * Check if device and browser is supported by MyStage
 */
const isBrowserSupported = () => {
  const device = new UAParser().getResult();
  const isMobileSupport = device.os.name == 'iOS' || device.os.name == 'Android';

  const isSupported = supportedBrowsers.filter(browser => {
    return (
      browser.name == device.browser.name &&
      browser.minVersion <= device.browser.major &&
      (isMobileSupport ? browser.os.includes(device.os.name) : true)
    );
  });
  return isSupported.length;
};

const isBrowserSupportsNetworkInfo = () => {
  try {
    return (typeof navigator.connection === 'object');
  } catch (error) {
    logger.error('Error encountered on isBrowserSupportsNetworkInfo ' + error,{ event_type:27 });
  }
};

let debounce = (fn, delay) => {
  let timeoutID = null;
  return function() {
    clearTimeout(timeoutID);
    let args = arguments;
    let that = this;
    timeoutID = setTimeout(function() {
      fn.apply(that, args);
    }, delay);
  };
};

const store = {
  get: function(key, defaultValue) {
    if (typeof Storage === 'undefined') {
      logger.error('Web Storage is not supported by this browser.',{ event_type:28 });
      return null;
    }
    let val = localStorage.getItem(key);
    return val !== null ? val : defaultValue;
  },

  set: function(key, value) {
    if (typeof Storage === 'undefined') {
      logger.error('Web Storage is not supported by this browser.',{ event_type:28 });
      return null;
    }
    localStorage.setItem(key, value);
  },

  clear: function(key) {
    if (typeof Storage === 'undefined') {
      logger.error('Web Storage is not supported by this browser.',{ event_type:28 });
      return null;
    }
    localStorage.removeItem(key);
  },

  getColor: function(defaultColor) {
    return this.get('mystage_lesson_color', defaultColor);
  },

  setColor: function(color) {
    this.set('mystage_lesson_color', color);
  },

  getLang: function(lang) {
    return this.get('mystage_lesson_lang', lang);
  },

  setLang: function(lang) {
    this.set('mystage_lesson_lang', lang);
  },

  getBool: function(key, defaultValue) {
    if (typeof Storage === 'undefined') {
      logger.error('Web Storage is not supported by this browser.',{ event_type:27 });
      return null;
    }

    switch (localStorage.getItem(key)) {
      case 'true':
        return true;
      case 'false':
        return false;
      default:
        return defaultValue;
    }
  },

  getCameraState: function() {
    return this.getBool(`mystage_cameraState`, true);
  },

  setCameraState: function(state) {
    this.set(`mystage_cameraState`, state);
  },

  getTranscribeState: function(lessonId, state) {
    return this.getBool(`mystage-transcribe_${lessonId}`, state);
  },

  setTranscribeState: function(lessonId, state) {
    this.set(`mystage-transcribe_${lessonId}`, state);
  },

  getAgoraRecordState: function(lessonId, state) {
    return this.getBool(`mystage-agoraRecord_${lessonId}`, state);
  },

  setAgoraRecordState: function(lessonId, state) {
    this.set(`mystage-agoraRecord_${lessonId}`, state);
  },

  getMicState: function() {
    return this.getBool(`mystage_micState`, true);
  },

  setMicState: function(state) {
    this.set(`mystage_micState`, state);
  },

  getCameraId: function(userId, options = {}) {
    const { skipGlobal = false } = options;

    // 1. User-scoped device ID
    if (userId) {
      const userDeviceId = this.get(`mystage_cameraId_${userId}`, null);
      if (userDeviceId) return userDeviceId;

      // 2. User-scoped label match
      const userLabel = this.get(`mystage_cameraLabel_${userId}`, null);
      if (userLabel) {
        const match = mainStore.state.devices.cameras?.find(d => d.label === userLabel);
        if (match) return match.deviceId;
      }
    }

    if (skipGlobal) return null;

    // 3. Global device ID
    const globalDeviceId = this.get(`mystage_cameraId_global`, null);
    if (globalDeviceId) return globalDeviceId;

    // 4. Global label match
    const globalLabel = this.get(`mystage_cameraLabel_global`, null);
    if (globalLabel) {
      const match = mainStore.state.devices.cameras?.find(d => d.label === globalLabel);
      if (match) return match.deviceId;
    }

    // 5. Legacy fallback — check per-lesson key for seamless deploy transition
    // Can be removed once all users have transitioned to per-user keys.
    const lessonId = mainStore.state.lessonId;
    if (lessonId) {
      const legacyDeviceId = this.get(`mystage_cameraId_${lessonId}`, null);
      if (legacyDeviceId) return legacyDeviceId;
    }

    return null;
  },

  setCameraId: function(userId, cameraId, isManual = false) {
    // Read previous value before overwriting (for manual flag comparison)
    const previousDeviceId = userId ? this.getCameraId(userId, { skipGlobal: true }) : null;

    // Write device ID to user-scoped and global keys
    if (userId) {
      this.set(`mystage_cameraId_${userId}`, cameraId);
    }
    this.set(`mystage_cameraId_global`, cameraId);

    // Write manual flag (per-user only)
    if (userId) {
      if (isManual) {
        this.set(`mystage_cameraManual_${userId}`, 'true');
      } else {
        if (previousDeviceId !== cameraId) {
          this.set(`mystage_cameraManual_${userId}`, 'false');
        }
      }
    }

    // Resolve and write label from devices store (best-effort, never throws)
    const cameras = mainStore.state.devices.cameras;
    const device = cameraId ? cameras?.find(d => d.deviceId === cameraId) : null;
    const cameraLabel = device?.label || null;
    if (userId) {
      this.set(`mystage_cameraLabel_${userId}`, cameraLabel);
    }
    this.set(`mystage_cameraLabel_global`, cameraLabel);
  },

  getMicId: function(userId, options = {}) {
    const { skipGlobal = false } = options;

    // 1. User-scoped device ID
    if (userId) {
      const userDeviceId = this.get(`mystage_micId_${userId}`, null);
      if (userDeviceId) return userDeviceId;

      // 2. User-scoped label match
      const userLabel = this.get(`mystage_micLabel_${userId}`, null);
      if (userLabel) {
        const match = mainStore.state.devices.mics?.find(d => d.label === userLabel);
        if (match) return match.deviceId;
      }
    }

    if (skipGlobal) return null;

    // 3. Global device ID
    const globalDeviceId = this.get(`mystage_micId_global`, null);
    if (globalDeviceId) return globalDeviceId;

    // 4. Global label match
    const globalLabel = this.get(`mystage_micLabel_global`, null);
    if (globalLabel) {
      const match = mainStore.state.devices.mics?.find(d => d.label === globalLabel);
      if (match) return match.deviceId;
    }

    // 5. Legacy fallback — check per-lesson key for seamless deploy transition
    // Can be removed once all users have transitioned to per-user keys.
    const lessonId = mainStore.state.lessonId;
    if (lessonId) {
      const legacyDeviceId = this.get(`mystage_micId_${lessonId}`, null);
      if (legacyDeviceId) return legacyDeviceId;
    }

    return null;
  },

  setMicId: function(userId, micId, isManual = false) {
    // Read previous value before overwriting (for manual flag comparison)
    const previousDeviceId = userId ? this.getMicId(userId, { skipGlobal: true }) : null;

    // Write device ID to user-scoped and global keys
    if (userId) {
      this.set(`mystage_micId_${userId}`, micId);
    }
    this.set(`mystage_micId_global`, micId);

    // Write manual flag (per-user only)
    if (userId) {
      if (isManual) {
        this.set(`mystage_micManual_${userId}`, 'true');
      } else {
        if (previousDeviceId !== micId) {
          this.set(`mystage_micManual_${userId}`, 'false');
        }
      }
    }

    // Resolve and write label from devices store (best-effort, never throws)
    const mics = mainStore.state.devices.mics;
    const micDevice = micId ? mics?.find(d => d.deviceId === micId) : null;
    const micLabel = micDevice?.label || null;
    if (userId) {
      this.set(`mystage_micLabel_${userId}`, micLabel);
    }
    this.set(`mystage_micLabel_global`, micLabel);
  },

  setSpeakerId: function(userId, speakerId, isManual = false) {
    // Read previous value before overwriting (for manual flag comparison)
    const previousDeviceId = userId ? this.getSpeakerId(userId, { skipGlobal: true }) : null;

    // Write device ID to user-scoped and global keys
    if (userId) {
      this.set(`mystage_speakerId_${userId}`, speakerId);
    }
    this.set(`mystage_speakerId_global`, speakerId);

    // Write manual flag (per-user only)
    if (userId) {
      if (isManual) {
        this.set(`mystage_speakerManual_${userId}`, 'true');
      } else {
        if (previousDeviceId !== speakerId) {
          this.set(`mystage_speakerManual_${userId}`, 'false');
        }
      }
    }

    // Resolve and write label from devices store (best-effort, never throws)
    const speakers = mainStore.state.devices.speakers;
    const speakerDevice = speakerId ? speakers?.find(d => d.deviceId === speakerId) : null;
    const speakerLabel = speakerDevice?.label || null;
    if (userId) {
      this.set(`mystage_speakerLabel_${userId}`, speakerLabel);
    }
    this.set(`mystage_speakerLabel_global`, speakerLabel);
  },

  getSpeakerId: function(userId, options = {}) {
    const { skipGlobal = false } = options;

    // 1. User-scoped device ID
    if (userId) {
      const userDeviceId = this.get(`mystage_speakerId_${userId}`, null);
      if (userDeviceId) return userDeviceId;

      // 2. User-scoped label match
      const userLabel = this.get(`mystage_speakerLabel_${userId}`, null);
      if (userLabel) {
        const match = mainStore.state.devices.speakers?.find(d => d.label === userLabel);
        if (match) return match.deviceId;
      }
    }

    if (skipGlobal) return null;

    // 3. Global device ID
    const globalDeviceId = this.get(`mystage_speakerId_global`, null);
    if (globalDeviceId) return globalDeviceId;

    // 4. Global label match
    const globalLabel = this.get(`mystage_speakerLabel_global`, null);
    if (globalLabel) {
      const match = mainStore.state.devices.speakers?.find(d => d.label === globalLabel);
      if (match) return match.deviceId;
    }

    // 5. Legacy fallback — check per-lesson key for seamless deploy transition
    // Can be removed once all users have transitioned to per-user keys.
    const lessonId = mainStore.state.lessonId;
    if (lessonId) {
      const legacyDeviceId = this.get(`mystage_speakerId_${lessonId}`, null);
      if (legacyDeviceId) return legacyDeviceId;
    }

    return null;
  },

  setBlurState: function(state) {
    return this.set(`mystage_blurState`, state);
  },

  getBlurState: function() {
    return this.get(`mystage_blurState`, 'none');
  },

  getRtcWasReloaded: function() {
    let reloadValue = this.get(`rtcWasReloaded`, false);
    return reloadValue == null ? true : reloadValue;
  },

  setRtcWasReloaded: function(val) {
    return this.set(`rtcWasReloaded`, val);
  },

  getAssessmentCurrentLesson: function(lessonId) {
    return this.get(`assessment_currentLesson_${lessonId}`, 0);
  },

  setAssessmentCurrentLesson: function(lessonId, currentLesson) {
    return this.set(`assessment_currentLesson_${lessonId}`, currentLesson);
  },

  getLessonGeneratorCredentials: function(pageUrl) {
    return this.get(`lesson_generator_${pageUrl}`, null);
  },

  setLessonGeneratorCredentials: function(pageUrl, creds) {
    return this.set(`lesson_generator_${pageUrl}`, JSON.stringify(creds));
  },

  clearLessonGeneratorCredentials: function(pageUrl) {
    return this.clear(`lesson_generator_${pageUrl}`);
  },

  getHideRecordMessage: function(user) {
    return this.getBool(`hide_record_message_${user}`, null);
  },

  setHideRecordMessage: function(user, state) {
    this.set(`hide_record_message_${user}`, state);
  },

  getShowTour: function(lessonId) {
    return this.getBool(`show_tour_${lessonId}`, true);
  },

  setShowTour: function(lessonId, val) {
    this.set(`show_tour_${lessonId}`, val);
  },

  getHtmlBuilderInsertStatus: function(lessonId) {
    return this.getBool(`html_builder_${lessonId}`, null);
  },

  setHtmlBuilderInsertStatus: function(lessonId, state) {
    this.set(`html_builder_${lessonId}`, state);
  },

  setUsefulPhraseSeen: function(userId) {
    return this.set(`mystage_usefulPhrase_${userId}`, true);
  },

  getUsefulPhraseSeen: function(userId) {
    return this.get(`mystage_usefulPhrase_${userId}`, false);
  },

  getLog: function(lessonId) {
     const pendingLogs = this.get(`pending_logs_${lessonId}`, null);
     return pendingLogs ? JSON.parse(pendingLogs) : [];
  },

  addLog: function (lessonId, log) {
    return this.set(`pending_logs_${lessonId}`, JSON.stringify(log));
  },

  emptyLog: function (lessonId) {
    return this.set(`pending_logs_${lessonId}`, []);
  }
};

let copyText = (text) => {
  const targetId = '_hiddenTextArea_';

  let target = document.getElementById(targetId);
  if (!target) {
    target = document.createElement('textarea');
    target.style.position = 'absolute';
    target.style.left = '-9999px';
    target.style.top = '0';
    target.id = targetId;
    document.body.appendChild(target);
  }

  target.textContent = text;
  target.focus();
  target.setSelectionRange(0, target.value.length);

  // copy the selection
  let succeed;
  try {
    succeed = document.execCommand('copy');
  } catch (e) {
    logger.error('Copy is not supported by this browser. Try to manually copy the link/text.',{ event_type:29 });
    succeed = false;
  }

  // clear temporary content
  target.textContent = '';

  return succeed;
};

let isBrowserSupportSpeaker = () => {
  let browser = (new UAParser()).getBrowser();
  return (
    browser.name === browsers.chrome || 
    browser.name === browsers.edge
  );
};

let isMobileDeviceByUserAgent = () => {
  return (new UAParser()).getDevice().type === 'mobile';
};

let isMobileDeviceByUserAgentAndInAllowedList = () => {
  let browser = (new UAParser()).getBrowser();
  let deviceType = (new UAParser()).getDevice().type;
  const allowedList = [browsers.chrome, browsers.safari, browsers.edge];

  return (
    (allowedList.includes(browser.name)) && 
    ((deviceType === 'mobile') || (deviceType == undefined))
  )
}

const getContractTypeLabel = (id) => {
  const contract = contractTypes.find(item => item.id === parseInt(id, 10));
  return contract && contract.label ? contract.label : '';
};

let sendUserAgentLogData = (isStudent) => {
  const uaparser = new UAParser();
  const device = uaparser.getResult();
  if (device) {
    // log data
    const consolebizTransport = new bizTransport(mainStore.getters.logTransportToken);
    logger.add(consolebizTransport);

    if (isStudent) {
      logger.info('Successfully parsed user agent and device information', {
        operation: 'user-agent',
        first_lesson: mainStore.state.isFirstLesson,
        contract_type: getContractTypeLabel(mainStore.state.contractType),
        browser_supported: (isBrowserSupported() > 0),
        deviced_used: (uaparser.getDevice().type === 'mobile') ? 'Smartphone' : 'PC',
        browser: (device.browser && device.browser.name) ? device.browser.name : '',
        browser_version: (device.browser && device.browser.version) ? device.browser.version : '',
        os: (device.os && device.os.name) ? device.os.name : '',
        screen_width: screen.width,
        screen_height: screen.height,
        ua_parser: device
      });
    }

    if (!mainStore.state.isTest && !mainStore.state.isTrial) {
      logger.info('Local environment of user', {
        operation: 'record-local-environment',
        lesson_id: mainStore.state.lessonId,
        user_id: mainStore.state.userId,
        lesson_status: mainStore.state.lessonStatus,
        is_student: isStudent,
        deviced_used: (uaparser.getDevice().type === 'mobile') ? 'Smartphone' : 'PC',
        browser: (device.browser && device.browser.name) ? device.browser.name : '',
        browser_version: (device.browser && device.browser.version) ? device.browser.version : '',
        os: (device.os && device.os.name) ? device.os.name : '',
        screen_width: screen.width,
        screen_height: screen.height,
        ua: uaparser.getUA()
      });
    }

    logger.remove(consolebizTransport);
  }
};

const isStringExactMatch = (stringToCheck, text) => {
  const pattern = new RegExp(`(\\s|^)${escapeRegExp(text)}(\\s|$)`, 'g');
  return stringToCheck.match(pattern);
}

const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

const fuelToken = () => {
  if (document.cookie.length > 0) {
    let c_name = 'fuel_csrf_token';
    let c_start = document.cookie.indexOf(c_name + '=');
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      let c_end = document.cookie.indexOf(';', c_start);
      if (c_end == -1) {
        c_end = document.cookie.length;
      }
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return '';
};

// This function make sure that value is literal object
// Non enumerable object will be converted to literal
const toObjectLiteral = (object) => {
  if (typeof object == 'object') {
    let props = Object.getOwnPropertyNames(object);

    // interface instance will result of empty properties
    if (props.length === 0) {
      // this is to prevent vue state accidental mutation
      let shallowCopy = {...object};
      // get the own properties by getting the prototype first
      props = Object.getOwnPropertyNames(Object.getPrototypeOf(shallowCopy));

      let content = {}
      props.forEach(prop => content[prop] = toObjectLiteral(shallowCopy[prop]));
      return content;
    } else {
      return object;
    }

  } else {
    return object;
  }
};

const removeSpecificHtmlTag = (htmlString, tagName) => {
  // Construct the regular expression to match the specific tag (case-insensitive)
  // This regex matches both opening and closing tags, including attributes
  const regex = new RegExp(`<${tagName}(?:\\s[^>]*)?>|</${tagName}>`, 'gi');
  return htmlString.replace(regex, '');
};

export {
  removeSpecificHtmlTag,
  checkUserLocalTime,
  currentLocalDateTimeInUTC,
  redirectToHome,
  redirectToJwtError,
  redirectToLessonGeneratorLogin,
  formatTime,
  dateTimeFormattingFunc,
  toggleBodyClass,
  debounce,
  redirectToChatHistory,
  redirectToLesson,
  isBrowserSupported,
  store,
  copyText,
  isBrowserSupportsNetworkInfo,
  isBrowserSupportSpeaker,
  isMobileDeviceByUserAgent,
  isMobileDeviceByUserAgentAndInAllowedList,
  sendUserAgentLogData,
  isStringExactMatch,
  fuelToken,
  toObjectLiteral
};
